import React from "react";
// import PropTypes from "prop-types";
import { Title, List } from "rbx";
import { Link } from "react-router-dom";
import { useTodaysOrders } from "../../utils/hooks";

import Loading from "../Loading";

// Dispatch
// Order Entry
// Order Dispatching
// Order Booking

const Dispatcher = () => {
  const { data: orders = [], loading: ordersLoading } = useTodaysOrders();

  return ordersLoading ? (
    <div className="page-loading">
      <Loading />
    </div>
  ) : (
    <div>
      <Title>
        There are {orders.length} orders scheduled for pickup today.
      </Title>
      <List>
        <List.Item as={Link} tabIndex="-1" to="/dispatch/orders/new">
          New Order
        </List.Item>
        <List.Item as={Link} tabIndex="-1" to="/dispatch/orders">
          Orders
        </List.Item>
        <List.Item as={Link} tabIndex="-1" to="/dispatch/scheduling">
          Order Scheduling
        </List.Item>
        <List.Item as={Link} tabIndex="-1" to="/dispatch/order-dispatching">
          Order Dispatching
        </List.Item>
        <List.Item as={Link} tabIndex="-1" to="/fleet/vehicles">
          Fleet Vehicles
        </List.Item>
      </List>
    </div>
  );
};

Dispatcher.propTypes = {};

export default Dispatcher;
